import { render } from "./index.vue?vue&type=template&id=3bd4635b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3bd4635b&lang=scss&scoped=true"

import exportComponent from "D:\\McToWebsite\\www\\CustomerWork\\XiJiangDairy\\OfficialWebsite\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd4635b"]])

export default __exports__